
import KeenSlider from 'keen-slider';
export default KeenSlider;

function removeElement(element) {
  if (element) element.remove();
}

function createDiv(className) {
  const div = document.createElement('div');
  const classNames = className.split(' ');
  classNames.forEach((name) => div.classList.add(name));
  return div;
}

export function sliderArrows(slider) {
  let wrapper; let arrowLeft; let arrowRight; const isDesktop = window.matchMedia("(min-width: 990px)").matches;

  function markup(remove) {
    wrapperMarkup(remove);
    arrowMarkup(remove);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      if (!wrapper) return;
      const parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv('navigation-wrapper')
    slider.container.parentNode.appendChild(wrapper)
    wrapper.appendChild(slider.container)
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);
      return;
    }
    arrowLeft = createDiv('btn slick-arrow slick-prev');
    arrowRight = createDiv('btn slick-arrow slick-next');

    const slidesToMove = slider.options.slides ? slider.options.slides.perView === 'auto' ? isDesktop ? 3 : 1 : slider.options.slides.perView : 1;
    // console.log(slidesToMove, slider)

    arrowLeft.addEventListener('click', () => slider.moveToIdx(slider.track.details.rel - slidesToMove));
    arrowRight.addEventListener('click', () => slider.moveToIdx(slider.track.details.rel + slidesToMove));

    wrapper.appendChild(arrowLeft);
    wrapper.appendChild(arrowRight);
  }

  // function updateClasses() {
  //   const slide = slider.track.details.rel;
  //   slide === 0
  //     ? arrowLeft.classList.add('slick-disabled')
  //     : arrowLeft.classList.remove('slick-disabled');

  //   slide === slider.track.details.slides.length - 1
  //     ? arrowRight.classList.add('slick-disabled')
  //     : arrowRight.classList.remove('slick-disabled');
  // }

  slider.on('created', () => {
    // if (slider.options.slides.perView > slider.slides.length) return;
    if (slider.options.disabled) return;
    markup();
    // updateClasses();
    
    // setTimeout(() => {
    //   const imagesWrap = slider.container.querySelector('.images-wrap');
    //   if (imagesWrap) {
    //     const top = 0.5 * imagesWrap.offsetHeight + 'px';
    //     const arrows = slider.container.parentNode.querySelectorAll('.slick-arrow');
  
    //     arrows.forEach((arrow) => {
    //       arrow.style.top = top;
    //     });
    //   }
    // }, 100);
  });  
  slider.on('optionsChanged', () => {
    // console.log(2);
    markup(true);
    // if (slider.options.slides.perView > slider.slides.length) return;
    if (slider.options.disabled) return;
    markup();
    // updateClasses();
  });
  // slider.on('slideChanged', () => {
  //   if (slider.options.disabled) return;
  //   updateClasses();
  // });
  slider.on('destroyed', () => {
    // if (slider.options.slides.perView > slider.slides.length) return;
    markup(true);
  });
}

export function sliderDots(slider) {
  let wrapper, dots;

  function markup(remove) {
    wrapperMarkup(remove);
    dotMarkup(remove);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      if (!wrapper) return;
      const parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv('navigation-wrapper');
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
  }

  function dotMarkup(remove) {
    if (remove) {
      removeElement(dots);
      return;
    }
    dots = createDiv('dots')
    slider.track.details.slides.forEach((_e, idx) => {
      const dot = createDiv('dot');
      dot.addEventListener('click', () => slider.moveToIdx(idx));
      dots.appendChild(dot);
    })
    wrapper.appendChild(dots);
  }

  function updateClasses() {
    const slide = slider.track.details.rel;

    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add('dot--active')
        : dot.classList.remove('dot--active');
    });
  }

  slider.on('created', () => {
    if (slider.options.disabled) return;
    markup();
    updateClasses();
  });
  slider.on('optionsChanged', () => {
    markup(true);
    if (slider.options.disabled) return;
    markup();
    updateClasses();
  });
  slider.on('slideChanged', () => {
    if (slider.options.disabled) return;
    updateClasses();
  });
  slider.on('destroyed', () => {
    // if (slider.options.disabled) return;
    markup(true);
  });
}

export function sliderAutoPlay(slider) {
  let timeout; let mouseOver = false;
  const timer = slider.options.autoplay;

  function clearNextTimeout() {
    clearTimeout(timeout);
  }
  function nextTimeout() {
    clearTimeout(timeout);
    if (mouseOver) return;
    timeout = setTimeout(() => {
      slider.next();
    }, timer || 5000);
  }
  slider.on('created', () => {
    slider.container.classList.add('keen-loaded');
    slider.container.addEventListener('mouseover', () => {
      mouseOver = true;
      clearNextTimeout();
    });
    slider.container.addEventListener('mouseout', () => {
      mouseOver = false;
      nextTimeout();
    });
    nextTimeout();
  });
  slider.on('dragStarted', clearNextTimeout);
  slider.on('animationEnded', nextTimeout);
  slider.on('updated', nextTimeout);
}

export function upsellArrow(slider) {
  const container = slider.container.closest('[data-visely-widget-container]') || slider.container.closest('section');
  if (!container) return;

  const appendAfter = container.querySelector('.visely-recommendations-title');
  let arrowRight; 

  function markup(remove) {
    arrowMarkup(remove);
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowRight);
      return;
    }
    arrowRight = createDiv('btn slick-arrow slick-next');

    const slidesToMove = 1;
    arrowRight.addEventListener('click', () => slider.moveToIdx(slider.track.details.rel + slidesToMove));

    appendAfter.after(arrowRight);
  }

  slider.on('created', () => {
    if (slider.options.disabled) return;
    markup();
  });  
  slider.on('optionsChanged', () => {
    markup(true);
    if (slider.options.disabled) return;
    markup();
  });
  // slider.on('slideChanged', () => {
  //   if (slider.options.disabled) return;
  //   updateClasses();
  // });
  slider.on('destroyed', () => {
    markup(true);
  });
}